import script from "./MainContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./MainContainer.vue?vue&type=script&setup=true&lang=js"

import "./MainContainer.vue?vue&type=style&index=0&id=7580c91c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7580c91c"]])

export default __exports__